// export const BASE_URL=`http://localhost:8000/api`;
export const baseURL = `https://syngentabalconistaadmapi.rehagro.com.br/api`;
export const rememberPass = `https://aliancabalconista.rehagro.com.br/forgotpass`;
